import script from "./OptionsToOpenCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsToOpenCalculator.vue?vue&type=script&setup=true&lang=js"

import "./OptionsToOpenCalculator.vue?vue&type=style&index=0&id=50bb3536&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bb3536"]])

export default __exports__